import { createContext, useContext, useState, useCallback } from 'react';
import axios from 'axios';

const PanicContext = createContext(null);

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const PanicProvider = ({ children }) => {
  const [isPanicMode, setIsPanicMode] = useState(false);
  const [panicResult, setPanicResult] = useState(null);
  const [panicLoading, setPanicLoading] = useState(false);
  const [selectedScenario, setSelectedScenario] = useState('workplace');

  const triggerPanic = useCallback(async (scenarioType, briefContext) => {
    setIsPanicMode(true);
    setPanicLoading(true);
    
    try {
      const response = await axios.post(`${API}/panic`, {
        scenario_type: scenarioType || selectedScenario,
        brief_context: briefContext
      });
      setPanicResult(response.data);
    } catch (error) {
      console.error('Panic mode error:', error);
      setPanicResult({
        quick_script: "I need a moment to address something personal. I'll be right back.",
        assertive_version: "I'm handling a medical matter that requires my immediate attention.",
        immediate_tips: ["Stay calm and breathe", "You don't owe anyone an explanation", "Take care of yourself first"],
        risk_level: "low"
      });
    } finally {
      setPanicLoading(false);
    }
  }, [selectedScenario]);

  const closePanic = useCallback(() => {
    setIsPanicMode(false);
    setPanicResult(null);
  }, []);

  const value = {
    isPanicMode,
    panicResult,
    panicLoading,
    selectedScenario,
    setSelectedScenario,
    triggerPanic,
    closePanic
  };

  return <PanicContext.Provider value={value}>{children}</PanicContext.Provider>;
};

export const usePanic = () => {
  const context = useContext(PanicContext);
  if (!context) {
    throw new Error('usePanic must be used within PanicProvider');
  }
  return context;
};
